var map = {
	"./cost.png": "CE8t",
	"./gross_profit.png": "Gm/k",
	"./sales.png": "trHf",
	"./sales_m.png": "Zqou"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "EGrd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sales ^\.\/.*\.png$
// module id = EGrd
// module chunks = 1